import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getTemplateRequestKey } from '../../utils/keys';
export const useTemplateRequest = (options) => {
    const { variables, fields, useQueryOptions } = options;
    const { client } = useTribeClient();
    const templateRequestKey = getTemplateRequestKey({ variables, fields });
    return useQuery(templateRequestKey, () => client.templates.templateRequest(variables, fields), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useTemplateRequest.js.map